import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild, SimpleChanges } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import * as Models from '../../../../../../src/app/models/commonModels';
import { AldFormBaseComponent } from '../../../../../../src/app/shared/components/form/ald-form.component';
import { AuthenticationService } from '../../../../../../src/app/shared/services/authentication.service';
import { EnvironmentService } from '../../../../../../src/app/services/environment.service';
import { HelperService } from "../../../../../../src/app/services/helper/helper.service";
import { BannerService } from '../../../../../../src/app/shared/services/banner.service';

import { SettingsState } from '../../../../../../src/app/services/settings/settings.state';
import * as SettingsAction from '../../../../../../src/app/services/settings/settings.action';

import { User } from '../../../../../../src/app/models/user/user';

import { SettingsPreview } from '../../../../../../src/app/models/settings/settings';

import * as DepositeModels from '../../../../../../src/app/models/deposite/deposite';
import { AldState } from "../../../../../../src/app/services/ald/ald.state";
import * as AldActions from "../../../../../../src/app/services/ald/ald.action";
import * as RelocationOrderModels from '../../../../../../src/app/models/relocation-order/relocation-order';


import * as GarageVisitsModels from '../../../../../../src/app/models/garage-visits/garage-visits';
import * as GarageVisitsAction from '../../../../../../src/app/services/garage-visits/garage-visits.action';
import { GarageVisitsState } from '../../../../../../src/app/services/garage-visits/garage-visits.state';
import * as CarModels from "../../../../../../src/app/models/car/car";

import * as GarageModels from '../../../../../../src/app/models/garage/garage';
import { GarageSearchModel } from "../../../../../../src/app/models/garage/garageSearch";
import * as GarageActions from '../../../../../../src/app/services/garage/garage.action';
import { GarageState } from '../../../../../../src/app/services/garage/garage.state';

import * as MapModels from '../../../../../../src/app/models/map/map';
import { MapMarker, MapAddressRequestModel } from '../../../../../../src/app/models/map/map';
import { GoogleMapsLoaderService } from '../../../../../../src/app/services/map/google-maps-loader.service';

@Component({
  selector: 'app-relocation-order',
  templateUrl: './relocation-order.component.html',
  styleUrls: ['./relocation-order.component.scss']
})

export class RelocationOrderComponent extends AldFormBaseComponent implements OnInit {


  public deposite: DepositeModels.DepositeModel;

  private depositeId: number;

  public garages: GarageModels.GaragePreviewModel[];

  public selectedGarage: GarageModels.GaragePreviewModel;

  public selectedMarker: MapModels.MapMarker;

  public Markers: MapModels.MapMarker[];

  public Zoom: number = 6;

  // Mapa moze sie wyrenderowac dopiero po zaladowaniu skryptu Google Maps.
  public mapsLoaded = false;

  public isVisibleDialogRelocation: boolean = false;

  public Lat: number;
  public Lng: number;

  private requestRelocatoinOrderSave: Models.ContextRequest<DepositeModels.DepositeModel, GarageModels.GaragePreviewModel> = new Models.ContextRequest<DepositeModels.DepositeModel, GarageModels.GaragePreviewModel>();

  private requestGarages: Models.Request<DepositeModels.DepositeModel> = new Models.Request<DepositeModels.DepositeModel>();

  @Select(AldState.Deposite)
  Deposite$: Observable<Models.Response<DepositeModels.DepositeModel>>;

  @Select(AldState.RelocationGarages)
  garageListState$: Observable<Models.ResponseList<GarageModels.GaragePreviewModel>>;

  @Select(AldState.RelocationOrder)
  RelocationOrder$: Observable<Models.Response<RelocationOrderModels.RelocationOrderModel>>;

  constructor(
        private formBuilder: FormBuilder,
        public router: Router,
        public authenticationService: AuthenticationService,
        public store: Store,
        public helperService: HelperService,
        public environmentService: EnvironmentService,
        public changeDetectorRef: ChangeDetectorRef,
        public activatedRoute: ActivatedRoute,
        private bannerService: BannerService,
        private googleMapsLoader: GoogleMapsLoaderService
  ) {

    super(helperService, environmentService, changeDetectorRef, router, authenticationService, store);

    //ŁÓDŹ
    this.selectedMarker = {
      Lat: 51.7730971,
      Lng: 19.4105533,
      Www: '',
      Label: '',
      Title: '',
      Draggable: false
    }

    this.Lat = this.selectedMarker.Lat;

    this.Lng = this.selectedMarker.Lng;
  }

  ngOnInit() {

    this.googleMapsLoader.load().then(() => {
      this.mapsLoaded = true;
      this.changeDetectorRef.detectChanges();
    });

    super.ngOnInit();

    this.subscription.add(this.Deposite$.subscribe((data) => {

      if (data && data.Success) {

        this.deposite = data.Item;

        this.requestGarages.Item = this.deposite;

        this.requestGarages.Begin();

        this.store.dispatch(new AldActions.RelocationGarageGet(this.requestGarages));


        }
    }));

    this.subscription.add(this.RelocationOrder$.subscribe((data) => {

      if (data && data.RequestSignature == this.requestRelocatoinOrderSave.RequestSignature) {

        this.isVisibleDialogRelocation = false;

        if (data.Success) {

          this.bannerService.instantSuccess("Zarejestrowano nowe zlecenie relokacji nr " + data.Item.Number);

          this.onHome();
        }
        else {

          this.onDeposites();
        }
      }
    }));


    this.subscription.add(
      this.garageListState$.subscribe((data) => {
        if (data && data.RequestSignature == this.requestGarages.RequestSignature) {

          this.garages = data.Items;

          this.requestGarages.End();

          this.Markers = this.garages.filter(g => g.Latitude && g.Longitude).map((g) => this.GetMarker(g));
        }
      })
    );
  }

  private GetMarker(Garage: GarageModels.GaragePreviewModel): MapModels.MapMarker {

    let marker: MapModels.MapMarker = new MapModels.MapMarker();

    // API zwraca wspolrzedne jako tekst, a @angular/google-maps wymaga liczb.
    marker.Lat = Number(Garage.Latitude);
    marker.Lng = Number(Garage.Longitude);
    marker.Title = Garage.Name;

    return marker;
  }

  public onUserAuthenitcate() {

    if (this.currentUser && this.currentUser.CarId) {

      this.activatedRoute.paramMap.subscribe(params => {
        this.depositeId = +params.get('id');

        if (this.depositeId) {

          this.requestGetDeposite = new Models.RequestModel(this.depositeId);

          this.store.dispatch(new AldActions.DepositeGet(this.requestGetDeposite));
        }
      });
    }
  };


  public onSummary() { }

  onMarkerClik(marker: MapModels.MapMarker) {


    this.selectedGarage = this.garages.filter(g => Number(g.Latitude) === marker.Lat && Number(g.Longitude) === marker.Lng)[0];

    this.selectedMarker = this.GetMarker(this.selectedGarage);

    this.isVisibleDialogRelocation = true;
  }

  onZoomChange($event) {
    this.Zoom = $event;
  }

  onConfirmRelocationClick() {
    this.requestRelocatoinOrderSave.Context = this.deposite;
    this.requestRelocatoinOrderSave.Item = this.selectedGarage;
    this.requestRelocatoinOrderSave.Begin();

    this.store.dispatch(new AldActions.RelocationOrderCreate(this.requestRelocatoinOrderSave));
  }

  onCancelRelocationClick() {
    this.isVisibleDialogRelocation = false;
  }
}
